import React, { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';

import Spinner from 'components/Spinner';
import { startPlaid } from 'actions/plaid';
import { useConfig } from 'config/ConfigContext';

const withPlaidSessionId = (WrappedComponent) => {
  const HOC = (props) => {
    const { apiUrl } = useConfig();
    const location = useLocation();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const workflow = useSelector((state) => get(state, 'workflow'));
    const [sessionId, setSessionId] = useState(null);
    const [linkToken, setLinkToken] = useState(null);

    useEffect(() => {
      const applicationId = searchParams.get('appId');
      const appId = applicationId || get(workflow, 'attributes.entityId');

      if (appId && !linkToken) {
        dispatch(startPlaid({
          data: {
            entityType: 'application',
            entityId: appId,
          },
          apiUrl: `${apiUrl}/plaid`,
          url: '/session',
          success: (session) => {
            setSessionId(session.id);
            setLinkToken(session.linkToken);
          },
          fail: (err) => {
            console.log('Initiating Session failed', err);
          },
        }));
      }
    }, [location.pathname]);

    return sessionId ?
      <WrappedComponent {...props} sessionId={sessionId} linkToken={linkToken} />
      :
      <Spinner className="my-4" color="blue-400" />
  };

  HOC.propTypes = {
  };

  return HOC;
};

export default withPlaidSessionId;
